<div class="page" *ngIf="!loading">
  <div class="login">
    <div class="project-logo">
      <!-- <img src="./assets/images/portal.gif" width="500" /> -->
        <img [src]="gifUrl" width=" ">
    </div>
    <div class="project-title">
      <div>Портал объектов</div>
      <div>{{companyName}}</div>
    </div>
    <div class="login_form">
      <div class="form-group">
        <input type="text" placeholder="Введите email" [(ngModel)]="data.username"/>
      </div>
      <div class="form-group">
        <input type="password" placeholder="Введите пароль" [(ngModel)]="data.password" (keydown)="authByEnter($event)"/>
      </div>
      <div *ngIf="errorMessage" class="error"> {{errorMessage}} </div>
      <div class="button" (click)="auth()">Войти</div>
    </div>
  </div>
  <div class="splash">
    <div class="digital_baiterek">
      <a href="http://digital.baiterek.gov.kz/" target="_blank"><img src="./assets/images/digital-baiterek.png"/></a>
    </div>
    <div class="splash_triangle"></div>
  </div>
  <div class="contacts">
    <div class="contacts_block">
        <!-- <a href="http://idet.kz" target="_blank"> <img class="idet" src="./assets/images/logo.gif" alt=""> </a> -->
        <a class="logo" href="https://idet.kz" target="_blank"><img class="idet" src="./assets/images/idet.png" alt=""></a>
        <a class="logo" href="https://satbayev.university/" target="_blank"><img class="su" src="./assets/images/su.png"/></a>
        <a class="logo" href="https://khc.kz/equity/" target="_blank"><img class="bd" src="./assets/images/kik.png"/></a>
    </div>
    <div class="contacts_block yellow">
        <span>Тех. поддержка (пн. - пт., с 08:30 до 18:00)</span>
        <span>+7 7172 79 75 75 (2768)</span>
        <span><a [attr.href]="'mailto:' + mail">{{mail}}</a></span>
    </div>
  </div>
  <div class="slider">
    <div class="slide" *ngFor="let slide of slides" [ngStyle]="{background: 'url('+slide.image+')'}" [ngClass]="slide.active ? 'active' : ''"></div>
  </div>
</div>
<div class="loading" *ngIf="loading"></div>
